export const SelectedResultItemQuestions = {
  productRangeKey: 'affordabilityCalculator.results.',
  repaymentsKey: 'affordabilityCalculator.results.repayments',
  initialRateKey: 'affordabilityCalculator.results.initialRate',
  maxFinancingKey: 'affordabilityCalculator.results.maxFinancing',
  maxFinancingRequestedKey: 'affordabilityCalculator.results.maxFinancingRequested',
  selectedProductKey: 'affordabilityCalculator.results.selectedProduct',
  typeKey: 'affordabilityCalculator.results.type',
  typeValueKey: 'affordabilityCalculator.results.type.',
  ltvKey: 'affordabilityCalculator.results.ltv',
  initialTermLabelKey: 'affordabilityCalculator.results.initialTerm.label',
  initialTermValueKey: 'affordabilityCalculator.results.initialTerm.value',
};
